module.exports = __webpack_public_path__ + "img/ModularWallV8.33138234.jpg";